import { customerLogout } from '@porterin/booking-flow/src/auth/domain/repo/customerLogout';
import {
  deleteCookie,
  getAuthCookies,
} from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';

import { AuthUser } from '../../../../containers/login/view-model/contexts/auth-context/AuthContextV1';

export async function logoutHandler(
  setUser: (user: AuthUser | undefined) => void,
  setIsAuthenticated: (value: boolean) => void,
  setIsMobileMenuOpen: (updater: (prev: boolean) => boolean) => void,
): Promise<void> {
  const { authToken, mobile, trackingId } = getAuthCookies();

  try {
    const result = await customerLogout(trackingId, authToken, mobile);
    if (result.logoutSuccess) {
      deleteCookie('auth-token');
      deleteCookie('mobile');
      setUser(undefined);
      setIsAuthenticated(false);
      setIsMobileMenuOpen(prev => !prev);
    }
  } catch {
    return;
  }
}
